import { useEffect, useRef } from 'react';

/**
 * Come setInterval, ma fermo quando la scheda non si vede; appena torna
 * visibile aggiorna subito. Una scheda dimenticata aperta non interroga il
 * server tutto il giorno.
 */
export default function useIntervallo(fn, ms, attivo = true) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!attivo || !ms) return undefined;
    const giro = () => { if (!document.hidden) ref.current(); };
    const timer = setInterval(giro, ms);
    document.addEventListener('visibilitychange', giro);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', giro); };
  }, [ms, attivo]);
}
